<button
  type="button"
  class="bubble"
  [class.bubble--attention]="attention"
  [class.bubble--dragging]="dragging"
  aria-label="Open Buddy (Alt+Space)"
  (pointerdown)="onPointerDown($event)"
  (click)="onClick()"
>
  <span class="bubble__disc">
    <app-bb-mascot [state]="bbState" [stage]="stage" [size]="36" [decorative]="true"></app-bb-mascot>
  </span>

  <!-- The ring is the XP bar in collapsed form. -->
  <svg class="bubble__ring" width="60" height="60" viewBox="0 0 60 60" fill="none" aria-hidden="true">
    <circle cx="30" cy="30" r="28" [attr.stroke]="trackColor" stroke-width="2.5" fill="none" />
    <circle
      class="bubble__ring-fill"
      cx="30"
      cy="30"
      r="28"
      [attr.stroke]="xpColor"
      stroke-width="2.5"
      fill="none"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset"
      transform="rotate(-90 30 30)"
    />
  </svg>
</button>
